import React, { Component } from 'react';
import SVGComponent from '../../components/SVG/SVGComponent';
import { SVG_ICONS } from '../../constants';

class AddPlayersTemplateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDropdownTemplateFilesOpen: false,
      templateFileSelected: null,
      competitionSelected: null,
    };
  }

  toggleDropdownTemplateFiles = () => {
    this.setState({ isDropdownTemplateFilesOpen: !this.state.isDropdownTemplateFilesOpen });
  };

  selectTemplateFile = (templateFile) => {
    this.setState({ templateFileSelected: templateFile });
  };

  changeLeagueSelected = (league) => {
    this.setState({ competitionSelected: league });
  };

  applyPlayersTemplatePreview = () => {
    this.props.applyPlayersTemplatePreview({
      playerTemplateFileId: this.state.templateFileSelected?.id,
      competitionId: this.state.competitionSelected?.id,
    });
  };

  render() {
    return (
      <>
        <div className="overlay-mask overlay-mask--open" />
        <div className="modal modal--open">
          <div className="dialog dialog--interval">
            <div className="dialog__heading">
              <span className="dialog__title">{this.props.titleName}</span>
              <SVGComponent
                src={`${SVG_ICONS.utility}#close`}
                className="dialog__close"
                onClick={this.props.closeModal}
              />
            </div>
            <div className="dialog__content">
              <div className="dialog__row">
                <div className="dialog__input-wrap" onClick={this.toggleDropdownTemplateFiles}>
                  <div
                    className={`dialog__input dialog__input--select 
                  ${this.state.isDropdownTemplateFilesOpen ? 'open' : ''}`}
                  >
                    <span>
                      {this.state.templateFileSelected?.fileName || 'Select a File'}
                    </span>
                  </div>
                  <div className="dialog__input-dropdown">
                    <div className="dialog__input-list">
                      {this.props.playersTemplateFile?.map((templateFile) => (
                        <div
                          className="dialog__input-list-item"
                          key={templateFile.id}
                          onClick={() => this.selectTemplateFile(templateFile)}
                        >
                          {templateFile.fileName}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="dialog__sub-title m-t-25">
                {this.props.selectDescription}
                {' '}
                :
              </div>
              <div className="dialog__league">
                <div className="row dialog__league-select">
                  {this.props.leagues?.map((league) => (
                    <div className="col-sm-4 m-t-10" key={league.id}>
                      <label className="checkbox">
                        <input type="radio" className="league-check" name="league" onClick={() => this.changeLeagueSelected(league)} />
                        <div className="checkbox__icon m-r-20" />
                        <span className="checkbox__label">{league.name}</span>
                      </label>
                    </div>
                  ))}

                </div>
              </div>
            </div>
            <div className="dialog__btn-wrap">
              <button className="btn btn-secondary" type="button" onClick={this.props.closeModal}>Cancel</button>
              <button
                className="btn btn-primary m-l-10"
                disabled={this.state.templateFileSelected === null
                || this.state.competitionSelected === null}
                onClick={this.applyPlayersTemplatePreview}
                type="button"
              >
                {this.props.saveBtnLabel}
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default AddPlayersTemplateModal;
